import { Text } from 'blaze-ui/Text/Text'
import Styles from './EditOption.module.scss'
import { ChevronRight } from 'blaze-ui/icons/24'
import { ReactNode } from 'react'
import cx from 'classnames'

interface Props {
  icon: ReactNode
  name: string
  rightContent?: ReactNode
  onClick?: () => void
  isDisabled?: boolean
}

export const EditOption = ({ icon, name, rightContent, onClick, isDisabled }: Props) => {
  return (
    <div className={cx(Styles.editOption, { [Styles.isDisabled]: isDisabled })} onClick={onClick}>
      <div className={Styles.icon}>{icon}</div>
      <div className={Styles.name}>
        <Text variant="largeList">{name}</Text>
      </div>
      <div className={Styles.rightSide}>
        <div className={Styles.rightContent}>{rightContent}</div>
        {isDisabled ? (
          <Text variant="placeholder" color="var(--color-60)">
            Coming soon
          </Text>
        ) : (
          <div className={Styles.chevron}>
            <ChevronRight />
          </div>
        )}
      </div>
    </div>
  )
}
